import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UniversityLabHeads = () => {
  const {id}=useParams()
  const navigate = useNavigate();
  const [deans, setDeans] = useState([]);
  const [search, setSearch] = useState("");
  // console.log("The lab heads are:",deans)
   const fetchDeans = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/university/labhead/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        setDeans(res?.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setDeans([]);
      }
    };
  useEffect(() => {
   

    fetchDeans();
  }, []);

  // Inline filtering
  const filteredDeans = deans.filter(
    (dean) =>
      dean?.profile_data?.name?.toLowerCase().includes(search.toLowerCase()) ||
      dean?.profile_data?.email?.toLowerCase().includes(search.toLowerCase())
  );
const handleDelete = async (id) => {

    const confirmDelete = window.confirm("Are you sure you want to delete this Lab head?");
    
    if (!confirmDelete) {
        return; // Stop if user clicks Cancel
    }

    try {
        const res = await axios.delete(
            `${BASE_URL}/marketplace/university/labhead/${id}/`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
            }
        );

        if (res.status === 204) {
            alert("Lab head Deleted Successfully");
            fetchDeans();
        }

    } catch (error) {
        console.log("Error while deleting dean", error);
    }
};

  return (
   <div className="p-6 max-w-6xl mx-auto">
  {/* Header */}
  <div className="flex items-center gap-3 mb-6">
    <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
      <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    </div>
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Lab Heads</h1>
      <p className="text-sm text-gray-500 mt-1">
        List of all lab heads with their contact details.
      </p>
    </div>
  </div>

  {/* Search and Add Bar */}
  <div className="w-full flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
  {/* Search Input */}
  <div className="relative flex-1 w-full">
    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
    <input
      type="text"
      placeholder="Search by name or email..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Add Button */}
  <button
    onClick={() => navigate(`/marketplace/${id}/dean/labhead/add`)}
    className="flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
    </svg>
    Add Lab Head
  </button>
</div>


  {/* Table */}
  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <table className="w-full">
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Profile</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Department</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Lab</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {filteredDeans.map((dean) => (
          <tr key={dean.id} className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4">
              <div className="relative w-10 h-10">
                <img
                  src={dean?.profile_data?.profile_picture}
                  alt={dean?.profile_data?.name}
                  className="w-10 h-10 rounded-xl object-cover border border-gray-200"
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
            </td>
            <td className="px-6 py-4">
              <p className="text-sm font-medium text-gray-900">{dean?.profile_data?.name}</p>
            </td>
            <td className="px-6 py-4">
              <p className="text-sm text-gray-600">{dean?.profile_data?.email}</p>
            </td>
             <td className="px-6 py-4">
              <p className="text-sm font-medium text-gray-900">{dean?.department_data?.name}</p>
            </td>
             <td className="px-6 py-4">
              <p className="text-sm font-medium text-gray-900">{dean?.lab_name}</p>
            </td>
            <td className="px-6 py-4">
              <button
                className="flex items-center gap-1 px-3 py-1.5 bg-red-50 text-red-600 text-sm font-medium rounded-lg hover:bg-red-100 transition-colors"
                onClick={() => handleDelete(dean?.id)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Delete
              </button>
            </td>
          </tr>
        ))}

        {filteredDeans.length === 0 && (
          <tr>
            <td colSpan={4} className="px-6 py-12 text-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <p className="text-gray-500 font-medium">No deans found</p>
                <p className="text-sm text-gray-400 mt-1">Add a dean or department head to get started</p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
  );
};

export default UniversityLabHeads;
